export interface IWarehouseAdminProductCategoryData {
    id: number;
    name: string;
}

export default class WarehouseAdminProductCategoryData {
    public id: number;
    public name: string;

    constructor(data: IWarehouseAdminProductCategoryData) {
        this.id = Number(data.id);
        this.name = data.name;
    }
}